import { useTranslation } from 'react-i18next';
import {
    Banner,
    BannerDescription,
    BannerEyebrow,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    FluidImage,
} from '@vp/swan';
import { sanitiseLocale } from '../../../../i18n/config';
import { useTrackNavigationClicked } from '../../../../utils/analytics';
import { logomakerCtaPathByLocale } from '../../../../utils/urls';
import LogomakerCTA from '../LogomakerCTA/LogomakerCTA';

const Hero = () => {
    const { i18n } = useTranslation();
    const locale = sanitiseLocale(i18n.language);

    const imageURL =
        'https://cms.cloudinary.vpsvc.com/image/upload/f_auto,q_auto/vista-logos-pages/en-US/logomaker-gen-ai/banner_pizzacats.webp';

    const logomakerCTARef = useTrackNavigationClicked(
        'Design Services',
        'Hero Banner CTA',
        logomakerCtaPathByLocale(locale),
        'logoMaker',
    );

    return (
        <Banner style={{ backgroundColor: '#FBD29B' }}>
            <BannerTextContainer>
                <BannerText>
                    <BannerEyebrow as="p">AI Logomaker by VistaPrint®</BannerEyebrow>
                    <BannerTitle as="h1">Create a free, AI logo you'll love</BannerTitle>
                    <BannerDescription as="p" style={{ textWrap: 'pretty' }}>
                        Get a logo made just for you with our generative AI logo maker. Built for
                        businesses like yours, it’s easy to refine ideas and get perfect,
                        print-ready files.
                    </BannerDescription>
                    <BannerLinks>
                        <LogomakerCTA ctaRef={logomakerCTARef} />
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
            <BannerImageContainer>
                <BannerImage>
                    <FluidImage
                        src={imageURL}
                        alt='Logo of a cat in red ninja armor, surrounded by pizza slices, with the text "Pizza Cats" and an input box below it saying "Create a pizza logo with a ninja cat"'
                        style={{ objectFit: 'contain' }}
                    />
                </BannerImage>
            </BannerImageContainer>
        </Banner>
    );
};

export default Hero;
